import { getCinemaSlug } from 'pages/Hall/helpers'

export default function gtmRemoveMealVoucher(voucherId, voucherName, price) {
    const cinemaid = localStorage.getItem('cinemaid')
    const site = getCinemaSlug(cinemaid)
    const ref = window.localStorage.getItem('referer')

    dataLayer.push({ ecommerce: null }) // Clear the previous ecommerce object.
    dataLayer.push({
        event: 'remove_from_cart',
        ecommerce: {
            currency: 'CZK',
            value: price,
            items: [
                {
                    affiliation: 'Cinestar',
                    item_list_id: ref,
                    item_list_name: ref,
                    item_id: voucherId,
                    item_name: voucherName,
                    item_brand: site,
                    item_category: 'Nákup',
                    item_category2: 'Meal',
                    discount: 0,
                    price: price,
                    quantity: 1,
                },
            ],
        },
    })
}
